import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';
import {useSelector} from 'react-redux';
import type {RootState} from '@/config/store';
import {STELLAR_WIDGET_SCRIPT_URL} from '@/utils/envvars';

const SCRIPT_ID = 'stellar-widget-script';

export const StellarWidget: React.FC = () => {
    const minimalToken = useSelector((state: RootState) => state.logins.minimalToken);

    useEffect(() => {
        if (!minimalToken) return;

        const baseUrl = STELLAR_WIDGET_SCRIPT_URL.trim();
        if (!baseUrl) return;

        const src = `${baseUrl}?bustCache=true`;

        if (!document.getElementById(SCRIPT_ID)) {
            const script = document.createElement('script');
            script.id = SCRIPT_ID;
            script.src = src;
            script.async = true;
            document.body.appendChild(script);
        }

        return () => {
            document.getElementById(SCRIPT_ID)?.remove();
        };
    }, [minimalToken]);

    if (!minimalToken) return null;

    return createPortal(
        <div
            id="stellar-widget"
            data-vendor="ptp-mx"
            data-token={minimalToken}
            data-language="es"
            data-default-corner="bottom-right"
        />,
        document.body
    );
};

export default StellarWidget;
